// extracted by mini-css-extract-plugin
export default {"initials":"q6OHb","initials--small":"AuNlp","initials--big":"lm98y"};